import gql from 'graphql-tag';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';
import { clients } from '../../../util/clients';

const { backend } = clients.direct;

const defaultSaiMonthlyTransactionFields = {
  _id: '',
  fiscalYear: '',
  section: '',
  saiMonthlySummary: '',
  bank: {
    _id: '',
    accountNumber: '',
    altKeyBase: '',
    bankCode: '',
    bankName: '',
    groupCode: '',
    routingNumber: '',
    bankAddress: '',
  },
  fund: {
    _id: '',
    fund: '',
    fiscalYear: '',
    description: '',
    altKey: '',
  },
  odDepartment: {
    id: '',
    dept: '',
    deptBalance: '',
    description: '',
  },
  banksMonthlyTransaction: {
    line: '',
    balPerBankStatement: '',
    investment: '',
    reconcilement: '',
    adjBankBalance: '',
    glBankBalance: '',
    difference: '',
    location: '',
    link: '',
    saiSection: '',
    isOD: '',
  },
  collectionMonthlyTransaction: {
    unapportionLastMonth: '',
    receipts: '',
    transferIn: '',
    transferOut: '',
    refundsPaymentCancelled: '',
    total: '',
    apportioned: '',
    balanceUnapportioned: '',
    link: '',
    saiSection: '',
  },
  fundsMonthlyTransaction: {
    line: '',
    description: '',
    balanceLastMonth: '',
    apportioned: '',
    transferIn: '',
    transferOut: '',
    disbursements: '',
    od: '',
    balance: '',
    link: '',
    saiSection: '',
  },
  odMonthlyTransaction: {
    link: '',
    saiSection: '',
    dept: '',
    description: '',
    balanceLastMonth: '',
    deposits: '',
    transferIn: '',
    transferOut: '',
    vouchersRegistered: '',
    balance: '',
  },
};

export const saiMonthlyTransaction = {
  namespaced: true,
  state: () => ({
    headers: undefined,
  }),
  mutations: {
    setHeaders(state, headers) {
      state.headers = headers;
    },
  },
  actions: {
    async loadSaiMonthlyTransaction({ commit, dispatch }, {
      criteria, fields, baseCrudKey,
    }) {
      let results;
      const gqlfields = fields || defaultSaiMonthlyTransactionFields;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query saiMonthlyTransaction($criteria: saiMonthlyTransactionCriteriaType) {
            saiMonthlyTransaction(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const saiMonthlyTrans = results.data ? results.data.saiMonthlyTransaction
            || [] : [];
        commit('base/crud/setItems', [baseCrudKey, saiMonthlyTrans], { root: true });
        return saiMonthlyTrans;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was problem loading the Transaction List!', { root: true });
      }
      return [];
    },
    async upsertSaiMonthlyTransaction({ dispatch, rootGetters, commit }, {
      item, fields, baseCrudKey,
    }) {
      let results;
      try {
        const gqlfields = fields || defaultSaiMonthlyTransactionFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertSaiMonthlyTransaction ($item: saiMonthlyTransactionInputType!)  {
                upsertSaiMonthlyTransaction(upsert: $item) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const saiMonthlySummaryTransStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newTransaction = results.data ? (results.data.upsertSaiMonthlyTransaction
            || {}) : {};
        const newList = mergeByIdNewAtTop(saiMonthlySummaryTransStateData || [], newTransaction);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
        return newTransaction;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the transaction!', { root: true });
      }
      return {};
    },
    async deleteSaiMonthlyTransaction({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteSaiMonthlyTransaction ($id: ID!)  {
            deleteSaiMonthlyTransaction(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data ? (results.data.deleteSaiMonthlyTransaction || {})._id : null;
        const saiMonthlyTransData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = saiMonthlyTransData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        return delId;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting the transaction!', { root: true });
      }
      return null;
    },
  },
};
export default saiMonthlyTransaction;
